<template>
  <svg
    :width="size.width"
    :height="size.height"
    viewBox="0 0 24 24"
    :fill="iconColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M18 6L6 18"
        :stroke="iconColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 6L18 18"
        :stroke="iconColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  iconColor: {
    type: String,
    default: '#FFFFFF',
  },
  size: {
    type: Object,
    default: () => ({
      height: 24,
      width: 24,
    }),
  },
});
</script>
